import { gql } from '@apollo/client';

import { GET_PRODUCT_OPERATION } from 'utils/constants';

export const GET_PRODUCT = gql`
  query ${GET_PRODUCT_OPERATION}($accountId: ID!, $input: GetProductsInput!, $images: ProductImageLookupFilter) {
    getAccount(accountId: $accountId) {
      accountId
      getProduct(input: $input) {
        product {
          id
          partName
          partNumber
          description
          productLine
          rmaFormViewable
          outOfWarrantyPrice
          outOfWarrantyEligible
          serialNumberType
          serialNumberLength
          getImages(input: $images) {
            imageName
            imageAbsoluteUrl
          }
        }
      }
    }
  }
`;
